import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CartState from "@store/Store/Pages/Cart/CartState";
import { Draft } from "immer";

const initialState: CartState = {
	selectedCartLineIds: [],
    incompatibleWithShipViaCartLineIds: [],
	isRemovingCartLines: false,
	isUpdatingCartLines: false,
    shipToOneTimeAddress: false,
};

const reducer = {
    "Store/Pages/Cart/SetCartLineIsIncompatibleWithShipVia": (
        draft: Draft<CartState>,
        action: { cartLineId: string; isIncompatibleWithShipVia: boolean },
    ) => {
        if (action.isIncompatibleWithShipVia) {
            draft.incompatibleWithShipViaCartLineIds = draft.incompatibleWithShipViaCartLineIds.concat([action.cartLineId]);
        } else {
            draft.incompatibleWithShipViaCartLineIds = draft.incompatibleWithShipViaCartLineIds.filter(o => o !== action.cartLineId);
        }
    },
	"Store/Pages/Cart/SetCartLineIsSelected": (
        draft: Draft<CartState>,
        action: { cartLineId: string; isSelected: boolean },
    ) => {
        if (action.isSelected) {
            draft.selectedCartLineIds = draft.selectedCartLineIds.concat([action.cartLineId]);
        } else {
            draft.selectedCartLineIds = draft.selectedCartLineIds.filter(o => o !== action.cartLineId);
        }
    },
	"Store/Pages/Cart/BeginRemoveCartLines": (draft: Draft<CartState>) => {
        draft.isRemovingCartLines = true;
    },
    "Store/Pages/Cart/CompleteRemoveCartLines": (draft: Draft<CartState>) => {
        draft.isRemovingCartLines = false;
    },
	"Store/Pages/Cart/BeginUpdateCartLines": (draft: Draft<CartState>) => {
        draft.isUpdatingCartLines = true;
    },
    "Store/Pages/Cart/CompleteUpdateCartLines": (draft: Draft<CartState>) => {
        draft.isUpdatingCartLines = false;
    },
    "Store/Pages/Cart/SetShipToOneTimeAddress": (
        draft: Draft<CartState>,
        action: {shipToOneTimeAddress: boolean},
    ) => {
        draft.shipToOneTimeAddress = action.shipToOneTimeAddress;
    },
};

const cartReducer = createTypedReducerWithImmer(initialState, reducer);
export default cartReducer;
